/** @format */

import React from "react";
import HeroBanner from "../assets/herobanner.svg";
import InnerHeroSection from "../components/landing/InnerHeroSection";

const Hero = () => {
  return (
    <div className="bg-[#FDF7FF]" id="hero">
      <div className="hero-bg  flex flex-col items-center">
        <div className="relative xl:px-24 px-8 pt-[145px] pb-[150px] items-center">
          <div>
            <h1 className="title text-[48px] font-extrabold text-white leading-[65px] tracking-[-0.02em]">
              HEALTH & FITNESS <br />
              TRACKER
            </h1>
            <p className="text-[20px] text-white tracking-[-0.02em] leading-[176.9%] font-normal mt-[24px] lg:w-[37%] md:w-[80%] w-[98%]">
              {`Can’t find the time to hit the gym and work out? FitStats lets you
              follow simple and effective home workouts to burn calories and get
              in shape.`}
            </p>
            <div className="flex sm:flex-row flex-col sm:space-x-6 sm:space-y-0 space-y-6 mt-[24px]">
              <a href="#footer">
                <button className="rounded-[4px] bg-[#8934A7] text-white py-[12px] px-[20px] w-full">
                  Get notified when the app launches
                </button>
              </a>
              <button className="rounded-[4px] bg-transparent text-[#85E2E9] py-[12px] px-[20px] border border-[#85E2E9] ">
                Explore more
              </button>
            </div>
          </div>
          <div className="hidden lg:flex absolute right-0 top-16 w-[70%] bottom-0">
            <img src={HeroBanner} alt="HeroBanner" className="" />
          </div>
        </div>
      </div>
      <InnerHeroSection />
    </div>
  );
};

export default Hero;
